import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import * as Icon from 'react-feather';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import BecomePartnerStickyBtn from '../BecomePartnerStickyBtn';
const settings4 = {
    // dots: true,
    nav: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    centerMode: true,
    centerPadding: '0',
    lazyLoad: true,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                initialSlide: 0
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        }
    ]
};

window.onload = function exampleFunction() {
    setTimeout(() => {
        var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
        (function () {
            var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
            s1.async = true;
            s1.src = 'https://embed.tawk.to/6375e747daff0e1306d7de2c/1gi28uspi';
            s1.charset = 'UTF-8';
            s1.setAttribute('crossorigin', '*');
            s0.parentNode.insertBefore(s1, s0);
        })();
    }, 15000);
}

// $(document).ready(function () {
//     setTimeout(function () {
//         $('.whatsapp-icon').append(` <a href="https://api.whatsapp.com/send?phone=918178480828" target="_blank"  className="wa-float">
//         <img src="assets/whatsapp-icon.webp"
//             className="img-fluid"
//             loading="lazy"
//         />
// </a>`);
//     }, 10000);
// });
const whatsapp_icon = {
    position: "fixed",
    bottom: "0",
    left: "10px",
    backgroundColor: "transparent",
    color: "#25d366",
    borderRadius: "50px",
    textAlign: "center",
    fontSize: "70px",
    zIndex: "999",
}
const Footer = () => {
    return (
        <>
            <footer className="footer-area custom-footer">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-12">
                            <div className="single-footer-widget">
                                <div className="logo">
                                    <Link to="/">
                                        <img
                                            src="assets/new-images/ft-logo-critsmas.png"
                                            alt="logo"
                                            loading="lazy"
                                        />
                                    </Link>
                                </div>
                                <div className="single-footer-widget mt-3 mt-md-0">
                                    <h3>Head Office</h3>
                                    <ul className="footer-contact-info">
                                        <li>
                                            {/* <i data-feather="map-pin" /> */}
                                            <Icon.MapPin />
                                            H-106, First Floor, Sector 63,
                                            <br />
                                            Noida - 201301
                                        </li>
                                        <li>
                                            {/* <i data-feather="mail" /> */}
                                            <Icon.Mail />
                                            <Link to="mailto:info@alobhatechnologies.com">
                                                info@alobhatechnologies.com
                                            </Link>
                                        </li>
                                        {/* <li class="d-flex"><i data-feather="phone-call"></i> Phone:
                                        <div> <a href="tel:01204101818">+91-0120 4101818</a>
                                            <a href="tel:9311639025">+91-9311639025</a>
                                        </div>
                                    </li> */}
                                    </ul>
                                </div>
                                <ul className="social-links">
                                    <li>
                                        <a
                                            href="https://www.facebook.com/AlobhaTechnology/"
                                            target="_blank"
                                            className="facebook"
                                        >
                                            <Icon.Facebook />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://twitter.com/AlobhaTech"
                                            target="_blank"
                                            className="twitter"
                                        >
                                            <Icon.Twitter />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.instagram.com/alobha_technologies/"
                                            target="_blank"
                                            className="instagram"
                                        >
                                            <Icon.Instagram />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.linkedin.com/company/alobha-technologies"
                                            target="_blank"
                                            className="linkedin"
                                        >
                                            <Icon.Linkedin />
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.youtube.com/@alobhatechnologies1722"
                                            target="_blank"
                                            className="youtube"
                                        >
                                            <Icon.Youtube />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-2 col-md-6 col-sm-12">
                            <div className="footer-heading links-bef-aft">
                                <h3>Quick links</h3>
                                <ul className="footer-contact-info">
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li>
                                        <Link to="/about-us">About Us</Link>
                                    </li>
                                    <li>
                                        <Link to="/services">Services</Link>
                                    </li>
                                    <li>
                                        <Link to="/portfolio">Portfolio</Link>
                                    </li>
                                    <li>
                                        <Link to="/career">Career</Link>
                                    </li>
                                    <li>
                                        <Link to="/contact-us">Contact us</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <div className="footer-heading links-bef-aft">
                                <h3>Top Services</h3>
                                <ul className="footer-contact-info">
                                    <li>
                                        <Link to="/web-development-company">Web Development</Link>
                                    </li>
                                    <li>
                                        <Link to="/mobile-app-development-company">Mobile App Development</Link>
                                    </li>
                                    <li>
                                        <Link to="/outsourcing-software-development-company">
                                            Outsourcing Software Development
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/cms-development-company">CMS Development</Link>
                                    </li>
                                    <li>
                                        <Link to="/erp-development-company">ERP</Link>
                                    </li>
                                    <li>
                                        <Link to="/digital-marketing-company">Digital Marketing</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-12 col-sm-12">
                            <div className="footer-heading links-bef-aft">
                                <h3>Reach Us</h3>
                                <div className="f-map-cus">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14008.5351645368!2d77.379102!3d28.625752!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce557e773a5db%3A0xa4b4dea3f4ae56cb!2sAlobha%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1664190754546!5m2!1sen!2sin"
                                        width="100%"
                                        height={250}
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-12 mb-3">
                            <div className="copyright text-md-left pt-15">
                                <h3 className="text-center text-white">Our Global Presence</h3>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="slider global-carousel">
                                <Slider {...settings4}>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/usa.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">USA</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/cameroon.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">Cameroon</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/australia.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">Australia</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/rwanda.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">Rwanda</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/france.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">France</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/dubai.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">Dubai</span>
                                        </div>
                                    </div>
                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/uk.webp"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">UK</span>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div className="d-flex align-items-center justify-content-center">
                                            <img
                                                src="assets/img/flags/sf.png"
                                                className="img-fluid"
                                                loading="lazy"
                                                alt='Footer Images'
                                                style={{
                                                    width: 40,
                                                    height: 40,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    marginRight: 5
                                                }}
                                            />
                                            <span className=" text-white font-weight-bold">South Africa</span>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
                {/* row */}
                <div className="row m-0">
                    <div className='col-lg-12 col-md-12'>
                        <div className='row'>
                            <div className="col-lg-6 col-md-6 p-0">
                                <div className="copyright-area">
                                    <p>Copyright @2014 Alobha Technologies Pvt. Ltd</p>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-6 p-0">
                                <div className="copyright-area tc-area">
                                    <Link to="/terms-and-conditions">Terms and conditions</Link>
                                    <Link to="/privacy-policy">Privacy policy</Link>
                                    <Link to="/non-refundable-policy">Non-Refundable policy</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='whatsapp-icon' style={whatsapp_icon}>
                        <a href="https://api.whatsapp.com/send?phone=918178480828" target="_blank" className="wa-float">
                            <img src="assets/whatsapp-icon.webp"
                                className="img-fluid"
                                loading="lazy"
                                alt='Whatsapp Images'
                            />
                        </a>
                    </div>
                    <BecomePartnerStickyBtn />
                </div>
                {/* <img src="assets/img/map.webp" className="map" alt="map" loading="lazy" /> */}
                {/* <div className="shape1">
                <img src="assets/img/shape1.webp" alt="shape" loading="lazy" />
                </div>
                <div className="shape8 rotateme">
                <img src="assets/img/shape2.svg" alt="shape" loading="lazy" />
                </div> */}
            </footer>
            <div className="go-top">
                {/* <i data-feather="arrow-up" /> */}
                <Icon.ArrowUp />
            </div>
        </>


    )
}

export default Footer